module.exports = __webpack_public_path__ + "media/img/android-icon-72x72-f982c496afbb150ca5f0d97503f75134.png";